module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackSemiExt.7e36aa7.eot";